import React, { createContext, useEffect, useState, useCallback } from "react";
import getBase64 from "../utils/getBase64";
import validTypeFile from "../utils/validTypeFile";

const PointAccessContext = createContext();

const PointAccessContextProvider = ({ children }) => {
  const [files, setFiles] = useState([]);
  const [imagesSelectedsModal, setImagesSelectedsModal] = useState([]);
  const [openModalImages, setOpenModalImages] = useState(false);
  const [openModalButtons, setOpenModalButtons] = useState(false);
  const [indexImageSelectToButtons, setIndexImageSelectToButtons] = useState();
  const [loadingDragDrop, setLoadingDradDrop] = useState(false);

  useEffect(() => {
    sessionStorage.setItem("filespontoacesso", JSON.stringify({ values: [] }));
  }, []);

  const handleAddFile = useCallback(
    async (filesInput) => {
      try {
        setLoadingDradDrop(true);
        let filesArr = [...files];

        if (filesArr.length === 0) {
          filesArr =
            JSON.parse(sessionStorage.filespontoacesso || "{}").values || [];
        }

        const copy = { ...filesInput };
        for (const item of Object.keys(copy)) {
          if (
            validTypeFile({
              file: copy[0],
              types: ["png", "PNG", "jpg", "JPG", "jpeg", "JPEG"],
            })
          ) {
            try {
              filesArr.push({
                url: URL.createObjectURL(copy[item]),
                file: await getBase64(copy[item]),
                new: true,
              });
            } catch (error) {}
          }
        }

        setFiles(filesArr);

        sessionStorage.setItem(
          "filespontoacesso",
          JSON.stringify({ values: filesArr })
        );
      } catch (error) {
        console.error("ERROR handleAddFile PointAccessContext", error);
      } finally {
        setLoadingDradDrop(false);
      }
    },
    [files]
  );

  const handleRemoveFile = useCallback(
    (img, index) => {
      const copyFiles = [...files];

      if (img.Id) {
        const indexFiles = files.findIndex((item) => item.Id === img.Id);
        if (indexFiles !== -1) {
          copyFiles.splice(indexFiles, 1);
          setFiles(copyFiles);
          sessionStorage.setItem(
            "filespontoacesso",
            JSON.stringify({ values: copyFiles })
          );
        }

        const indexSelectedsModal = imagesSelectedsModal.findIndex(
          (item) => item === img.Id
        );
        if (indexSelectedsModal !== -1) {
          const copySelectedsModal = [...imagesSelectedsModal];
          copySelectedsModal.splice(indexSelectedsModal, 1);
          setImagesSelectedsModal(copySelectedsModal);
        }

        return;
      }

      copyFiles.splice(index, 1);
      setFiles(copyFiles);
      sessionStorage.setItem(
        "filespontoacesso",
        JSON.stringify({ values: copyFiles })
      );
    },
    [files, imagesSelectedsModal]
  );

  const handleSelectImage = useCallback(
    (img) => {
      const indexFiles = files.findIndex((item) => item.Id === img.Id);
      if (indexFiles === -1) {
        setFiles([
          ...files,
          {
            url: `data:image/jpeg;base64,${img.ImagemB64}`,
            file: img.ImagemB64,
            Id: img.Id,
          },
        ]);

        sessionStorage.setItem(
          "filespontoacesso",
          JSON.stringify({
            values: [
              ...files,
              {
                url: `data:image/jpeg;base64,${img.ImagemB64}`,
                file: img.ImagemB64,
                Id: img.Id,
              },
            ],
          })
        );
      } else {
        const copyFiles = [...files];
        copyFiles.splice(indexFiles, 1);
        setFiles(copyFiles);
        sessionStorage.setItem(
          "filespontoacesso",
          JSON.stringify({ values: copyFiles })
        );
      }

      const indexSelected = imagesSelectedsModal.findIndex(
        (item) => item === img.Id
      );

      if (indexSelected === -1) {
        setImagesSelectedsModal([...imagesSelectedsModal, img.Id]);
      } else {
        const copySelecteds = [...imagesSelectedsModal];
        copySelecteds.splice(indexSelected, 1);
        setImagesSelectedsModal(copySelecteds);
      }
    },
    [files, imagesSelectedsModal]
  );

  const handleOpenModalButtons = (index) => {
    setOpenModalButtons(true);
    setIndexImageSelectToButtons(index);
  };

  const handleCloseModalButtons = () => {
    setOpenModalButtons(false);
    setIndexImageSelectToButtons(null);
  };

  const handleSelectButton = (idButton, indexFile) => {
    const copyFiles = [...files];

    if (copyFiles[indexFile].buttons) {
      const indexButtonExists = copyFiles[indexFile].buttons.findIndex(
        (item) => item === idButton
      );

      if (indexButtonExists === -1) {
        copyFiles[indexFile].buttons.push(idButton);
      } else {
        copyFiles[indexFile].buttons.splice(indexButtonExists, 1);
      }
    } else {
      copyFiles[indexFile].buttons = [idButton];
    }

    setFiles(copyFiles);
  };

  return (
    <PointAccessContext.Provider
      value={{
        files,
        setFiles,
        setImagesSelectedsModal,
        imagesSelectedsModal,
        handleAddFile,
        handleRemoveFile,
        handleSelectImage,
        setOpenModalImages,
        openModalImages,
        openModalButtons,
        handleOpenModalButtons,
        handleCloseModalButtons,
        indexImageSelectToButtons,
        handleSelectButton,
        loadingDragDrop,
      }}
    >
      {children}
    </PointAccessContext.Provider>
  );
};

export { PointAccessContextProvider, PointAccessContext };
